//const API_URL = 'http://192.168.101.200:8000'; // Localserver
const API_URL = 'https://testifyrbackend.your-product.in'; // Production server
export default API_URL;